import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import Sound from '../../../domain/entities/Sound';

export default function reducer(
  state: {[key: number]: Sound} = {},
  action: AnyAction,
): {[key: number]: Sound} {
  switch (action.type) {
    case Types.IndexSoundsSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (obj: {[key: number]: Sound}, record: Sound) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.ShowSoundSuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    default:
      return state;
  }
}
